import type { MethodItemMobile, TransferItemMobile } from '~/composables/account/interface'
import { AccountTabs } from '~/constants/account'
import { DEPOSIT_METHOD } from '~/constants'
import { useRuntimeConfig } from '#app'

const globImages: GlobImageI = import.meta.glob('~/assets/images/pages/account/mobile/*', { eager: true })
const iconImgUrl = '/assets/images/pages/account/mobile'

const DepositSectionMobile = defineAsyncComponent(async () => await import('~mobile/pages/account/deposit-section.vue'))
const WithdrawSectionMobile = defineAsyncComponent(
  async () => await import('~mobile/pages/account/withdraw-section.vue')
)
const TransferSectionMobile = defineAsyncComponent(async () => await import('~mobile/pages/account/transfer.vue'))
const Coin12Section = defineAsyncComponent(async () => await import('~common/account/coin-12.vue'))

const TransactionSectionMobile = defineAsyncComponent(
  async () => await import('~mobile/pages/account/history/transaction-section.vue')
)
const BettingSectionMobile = defineAsyncComponent(
  async () => await import('~mobile/pages/account/history/betting-section.vue')
)
const UserBankSectionMobile = defineAsyncComponent(
  async () => await import('~mobile/pages/account/information-bank.vue')
)
const RefundMobile = defineAsyncComponent(async () => await import('~/components/mobile/pages/account/info-refund.vue'))
const ProfileInformationMobile = defineAsyncComponent(
  async () => await import('~mobile/pages/account/profile-information.vue')
)

const InfoPersonalForm = defineAsyncComponent(async () => await import('~mobile/pages/account/info-personal-form.vue'))
const InfoPasswordForm = defineAsyncComponent(async () => await import('~mobile/pages/account/info-password-form.vue'))

export const accountMobileMenus = [
  { key: 'deposit', component: DepositSectionMobile },
  { key: 'withdraw', component: WithdrawSectionMobile },
  { key: 'transfer-money', component: TransferSectionMobile },
  { key: 'coin12', component: Coin12Section },
  { key: 'history-transaction', component: TransactionSectionMobile },
  { key: 'history-betting', component: BettingSectionMobile },
  { key: 'information', component: ProfileInformationMobile },
  { key: 'change-password', component: ProfileInformationMobile },
  { key: 'refund', component: ProfileInformationMobile },
  { key: 'user-bank', component: ProfileInformationMobile }
]

export const infoFormMenus = [
  { link: AccountTabs.INFORMATION, title: 'Thông tin tài khoản', component: InfoPersonalForm },
  { link: AccountTabs.CHANGE_PASSWORD, title: 'Đổi mật khẩu', component: InfoPasswordForm },
  { link: AccountTabs.REFUND, title: 'Khuyến mãi', component: RefundMobile },
  { link: AccountTabs.USER_BANK, title: 'Ngân hàng chính chủ', component: UserBankSectionMobile }
]

export const depositMethodsMobile: MethodItemMobile[] = [
  {
    name: 'QR FastPay',
    icon: getImageURL(globImages, 'tpay', iconImgUrl, 'png'),
    link: `${AccountTabs.DEPOSIT}&type=tpay`,
    method: DEPOSIT_METHOD.T_PAY,
    isMaintain: false
  },
  {
    name: 'QRPay',
    icon: getImageURL(globImages, 'qrpay', iconImgUrl, 'png'),
    link: `${AccountTabs.DEPOSIT}&type=qrpay`,
    method: DEPOSIT_METHOD.QR_PAY,
    isMaintain: false
  },
  // TODO: Deposit with bank just hidden temporarily. Should be totaly removed after about 2 months
  // {
  //   name: 'Phổ Thông',
  //   icon: getImageURL(globImages, 'bank', iconImgUrl, 'png'),
  //   link: `${AccountTabs.DEPOSIT}&type=ibanking`,
  //   method: DEPOSIT_METHOD.BANKING,
  //   isMaintain: false
  // },
  {
    name: 'Thẻ Cào',
    icon: getImageURL(globImages, 'phone', iconImgUrl, 'png'),
    link: `${AccountTabs.DEPOSIT}&type=phone_card`,
    method: DEPOSIT_METHOD.PHONE_CARD,
    isMaintain: false
  },
  {
    name: 'Ví Điện Tử',
    icon: getImageURL(globImages, 'wallet', iconImgUrl, 'png'),
    link: `${AccountTabs.DEPOSIT}&type=momo`,
    method: DEPOSIT_METHOD.MOMO,
    isMaintain: false
  },
  {
    name: 'Tiền Ảo',
    icon: getImageURL(globImages, 'crypto', iconImgUrl, 'png'),
    link: `${AccountTabs.DEPOSIT}&type=crypto`,
    method: DEPOSIT_METHOD.CRYPTO,
    isMaintain: false
  }
]

export const depositMethodsMobileMenu: MethodItemMobile[] = [
  {
    name: 'QR FastPay',
    icon: 'tpay',
    link: `${AccountTabs.DEPOSIT}&type=tpay`,
    isMaintain: false,
    label: getImageURL(globImages, 'label-fast-mobile', iconImgUrl, 'png'),
    method: DEPOSIT_METHOD.T_PAY
  },
  {
    name: 'QRPay',
    icon: 'qrpay',
    link: `${AccountTabs.DEPOSIT}&type=qrpay`,
    isMaintain: false,
    label: getImageURL(globImages, 'label-fast-mobile', iconImgUrl, 'png'),
    method: DEPOSIT_METHOD.QR_PAY
  },
  // TODO: Deposit with bank just hidden temporarily. Should be totaly removed after about 2 months
  // {
  //   name: 'Ngân Hàng',
  //   icon: 'bank',
  //   isMaintain: false,
  //   link: `${AccountTabs.DEPOSIT}&type=ibanking`,
  //   method: DEPOSIT_METHOD.BANKING
  // },
  {
    name: 'Thẻ Cào',
    link: `${AccountTabs.DEPOSIT}&type=phone_card`,
    isMaintain: false,
    icon: 'card',
    method: DEPOSIT_METHOD.PHONE_CARD
  },
  {
    name: 'Ví Điện Tử',
    link: `${AccountTabs.DEPOSIT}&type=momo`,
    isMaintain: false,
    icon: 'wallet',
    method: DEPOSIT_METHOD.MOMO
  },
  {
    name: 'Tiền Ảo',
    icon: 'crypto',
    link: `${AccountTabs.DEPOSIT}&type=crypto`,
    isMaintain: false,
    label: getImageURL(globImages, 'label-new-mobile', iconImgUrl, 'svg'),
    method: DEPOSIT_METHOD.CRYPTO
  }
]

export const getTransferLinks = (): TransferItemMobile[] => {
  const config = useRuntimeConfig().public
  const IS_FUND_TRANSFER_MAINTAINED = config.IS_FUND_TRANSFER_MAINTAINED === '1'
  return [
    {
      from: 'Ví Chính',
      to: 'Ví BONG88',
      label: 'Tạo phiếu chuyển ví',
      link: AccountTabs.TRANSFER_MONEY,
      icon: getImageURL(globImages, 'main-to-agency', iconImgUrl, 'webp'),
      isMaintain: IS_FUND_TRANSFER_MAINTAINED
    }
  ]
}

export const getWithdrawMethodsMobile = (): MethodItemMobile[] => {
  const config = useRuntimeConfig().public
  const IS_WIDTHDRAW_BANK_MAINTAINED = config.IS_WIDTHDRAW_BANK_MAINTAINED === '1'
  const IS_WIDTHDRAW_CARD_MAINTAINED = config.IS_WIDTHDRAW_CARD_MAINTAINED === '1'
  const IS_WIDTHDRAW_CRYPTO_MAINTAINED = config.IS_WIDTHDRAW_CRYPTO_MAINTAINED === '1'

  return [
    {
      name: 'Ngân Hàng',
      icon: getImageURL(globImages, 'bank', iconImgUrl, 'png'),
      isMaintain: IS_WIDTHDRAW_BANK_MAINTAINED,
      link: `${AccountTabs.WITHDRAW}&type=ibanking`
    },
    {
      name: 'Thẻ Cào',
      icon: getImageURL(globImages, 'phone', iconImgUrl, 'png'),
      link: `${AccountTabs.WITHDRAW}&type=phone_card`,
      isMaintain: IS_WIDTHDRAW_CARD_MAINTAINED
    },
    {
      name: 'Tiền Ảo',
      icon: getImageURL(globImages, 'crypto', iconImgUrl, 'png'),
      link: `${AccountTabs.WITHDRAW}&type=crypto`,
      isMaintain: IS_WIDTHDRAW_CRYPTO_MAINTAINED
    }
  ]
}

export const getWithdrawMethodsMobileMenu = (): MethodItemMobile[] => {
  const config = useRuntimeConfig().public
  const IS_WIDTHDRAW_BANK_MAINTAINED = config.IS_WIDTHDRAW_BANK_MAINTAINED === '1'
  const IS_WIDTHDRAW_CARD_MAINTAINED = config.IS_WIDTHDRAW_CARD_MAINTAINED === '1'
  const IS_WIDTHDRAW_CRYPTO_MAINTAINED = config.IS_WIDTHDRAW_CRYPTO_MAINTAINED === '1'

  return [
    {
      name: 'Ngân Hàng',
      icon: 'bank',
      isMaintain: IS_WIDTHDRAW_BANK_MAINTAINED,
      link: `${AccountTabs.WITHDRAW}&type=ibanking`
    },
    {
      name: 'Thẻ Cào',
      link: `${AccountTabs.WITHDRAW}&type=phone_card`,
      isMaintain: IS_WIDTHDRAW_CARD_MAINTAINED,
      icon: 'card'
    },
    {
      name: 'Tiền Ảo',
      link: `${AccountTabs.WITHDRAW}&type=crypto`,
      isMaintain: IS_WIDTHDRAW_CRYPTO_MAINTAINED,
      icon: 'crypto'
    }
  ]
}
